import Vue from 'vue'
import '../cube-ui'
import App from './App.vue'
import router from '../router'
import store from '../config/stores'

import IconSvg from '../components/common/IconSvg'
import '../icon/iconfont.js'
import "../styles/index.scss"
import {Lazyload, ImagePreview} from "vant";
import VueClipboard from 'vue-clipboard2'

Vue.use(ImagePreview)
Vue.use(Lazyload, {
  loading: "https://a1.wanwanshequ.com/static/public/loading-gif.gif",
  lazyComponent: true
});

Vue.use(VueClipboard)

import VueCookies from 'vue-cookies';

VueCookies.config('90d')
Vue.use(VueCookies)

Vue.component('icon-svg', IconSvg)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
